import http from "./http-common";

class TrainingPartDataService {

    getforTrainingId(trainingId) {
      return http.get(`/training/${trainingId}/parts`).then((response) => response.data ).catch(error => {throw error});
    }

    deleteTrainingPart(trainingPartId) {
      return http.delete(`/training/part/${trainingPartId}`).then((response) => response.data).catch(error => {throw error});
    }

    addTrainingPart(trainingPart) {
      return http.post(`/training/part/`, trainingPart).then((response) => response.data).catch(error => {throw error});
    }

    updateTrainingPart(trainingPart) {
      return http.put(`/training/part/${trainingPart.id}`, trainingPart).then((response) => response.data).catch(error => {throw error});
    }

}

const trainingPartDataServiceInstance = new TrainingPartDataService();
export default trainingPartDataServiceInstance;